import {
  Group,
  Stack,
  StepperStep,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import { IconBell, IconUser } from "@tabler/icons-react";
import { parseDate } from "../../../../../../../functions/dates";
import ItemDeleter from "../../../../../../../components/TableComponents/ItemDeleter";
import { deleteReminder } from "../../../../../../../api/PRMAPI";
import { useLeadsSheetStore } from "../../../../../../../stores/LeadsStore";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import { getCallColor, getDifference, reminderTypes } from "../../../../utils";

const ReminderItem = ({ item, isLast, isMobile }) => {
  const lang = useLanguage((s) => s.language);
  const current = useLeadsSheetStore((s) => s.current);
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);

  return (
    <Stack gap={4} mt={-6} w={"100%"}>
      <Group>
        <StepperStep
          component={Group}
          // align="start"
          miw={120}
          gap={0}
          pl={3}
          style={{ cursor: "text" }}
          icon={
            <Tooltip label={reminderTypes()[item.type]}>
              <ThemeIcon
                variant="white"
                radius={"lg"}
                style={{ boxShadow: "#00000021 1px 1px 3px" }}
                mt={-4}
                size={isMobile ? 12 : undefined}
              >
                <IconBell size={isMobile ? 0 : 18} />
              </ThemeIcon>
            </Tooltip>
          }
          label={
            <Stack
              gap={4}
              bg={"#fcfbff"}
              px={"sm"}
              pt={8}
              style={{
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                border: "1px solid #00000018",
                borderBottom: 0,
              }}
              miw={250}
            >
              <Text fw={500}>{item.name}</Text>
              <Group>
                <Text size="sm">{reminderTypes()[item.type]}</Text>

                <Group gap={4} ml={"auto"}>
                  <Tooltip label="Créé par">
                    <IconUser size={14} />
                  </Tooltip>
                  <Text size="sm">
                    {item.created_by.first_name} {item.created_by.last_name}
                  </Text>
                </Group>
              </Group>
            </Stack>
          }
          description={
            <Group
              bg={"#fcfbff"}
              px={"sm"}
              pb={6}
              mt={-4}
              pt={4}
              miw={120}
              style={{
                borderBottomLeftRadius: 12,
                borderBottomRightRadius: 12,
                border: "1px solid #00000018",
                borderTop: 0,
              }}
            >
              <Text size="md" c={getCallColor(item?.call_date)}>
                {parseDate(item?.call_date)}{" "}
              </Text>
            </Group>
          }
          mih={0}
        />

        <ItemDeleter
          title_bold={`${item.name} #${item.id}`}
          handleDelete={deleteReminder}
          parentId={current.id}
          deletedMessage={lang.prm.details.reminders.delete_success}
          id={item.id}
          disabled={!current?.permission?.write_permission || false}
          onFinish={() =>
            setCurrent({
              ...current,
              calls: current.calls.filter((x) => x.id !== item.id),
            })
          }
        />
      </Group>
      <Group
        mih={32}
        pl={26}
        style={{
          borderLeft: isLast ? "1px solid transparent" : "1px solid #00000021",
        }}
        ml={17}
        mt={-10}
      ></Group>
    </Stack>
  );
};

export default ReminderItem;
